import { Grid2, Typography } from "@mui/material";
import { memo, useEffect, useState } from "react";
import { Image } from "mui-image";

import Card from "../components/Card.js";
import Spinner from "../components/Spinner.js";
import { capitalize, jwt, useSnackbar } from "../utils/index.js";
import { getProfile } from "../api/index.js";

const Profile = () => {
	const { error } = useSnackbar();
	const [profile, setProfile] = useState(null);
	const [isLoading, setIsLoading] = useState(false);

	const fetchProfile = async () => {
		setIsLoading(true);
		const { success, profile: fetchedProfile } = await getProfile();
		if (success) {
			const role = jwt.decode().role;
			setProfile({ ...fetchedProfile, role });
		} else {
			error();
		}

		setIsLoading(false);
	};

	useEffect(() => {
		fetchProfile();
	}, []);
    
	return (
		<>
			<Spinner open={isLoading} />
			<Grid2 container display="flex" direction="column" justifyContent="center" alignItems="center">
				<Grid2 width={400}>
					<Card title="Profile">
						<Grid2 width="100%" display="flex" justifyContent="center">
							<Grid2 width={100} display="flex" justifyContent="center">
								<Image src={profile?.avatar} alt="Avatar" referrerPolicy="no-referrer" style={{ width: "auto", height: "100px", borderRadius: "100px", objectFit: "contain" }} />
							</Grid2>
							<Grid2 width={250} display="flex" justifyContent="center" flexDirection="column" sx={{ marginLeft: "50px" }}>
								<Typography>{`Username: ${profile?.username}`}</Typography>
								<Typography>{`Email: ${profile?.email}`}</Typography>
								<Typography>{`Role: ${capitalize(profile?.role)}`}</Typography>
							</Grid2>
						</Grid2>
					</Card>
				</Grid2>
			</Grid2>
		</>
	);
};

export default memo(Profile);
